import { render, staticRenderFns } from "./crownIcon.vue?vue&type=template&id=825576ec&scoped=true"
import script from "./crownIcon.vue?vue&type=script&lang=js"
export * from "./crownIcon.vue?vue&type=script&lang=js"
import style0 from "./crownIcon.vue?vue&type=style&index=0&id=825576ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825576ec",
  null
  
)

export default component.exports